module.exports = __webpack_public_path__ + "static/media/wave-no-content.8bb5fe16.svg";